import api from '../../../services/api';
import {
  TransportCompanyDto,
  TransportCompanyOptionDto,
  normalizeTransportCompany,
  normalizeTransportCompanyOptions,
} from '../../../dto/transportCompany';

export async function fetchTransportCompanyOptions(): Promise<TransportCompanyOptionDto[]> {
  const response = await api.get('/transport-companies');
  return normalizeTransportCompanyOptions(response.data, 'transportCompany.options');
}

export async function fetchTransportCompany(id: string): Promise<TransportCompanyDto | null> {
  const response = await api.get(`/transport-companies/${id}`);
  return normalizeTransportCompany(response.data, 'transportCompany.detail');
}

export interface TransportCompanyInput {
  name: string;
  nip?: string | null;
  contactPerson?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  notes?: string | null;
}

export async function createTransportCompany(data: TransportCompanyInput): Promise<TransportCompanyDto> {
  const response = await api.post('/transport-companies', data);
  const normalized = normalizeTransportCompany(response.data, 'transportCompany.create');
  if (!normalized) {
    throw new Error('Server returned an invalid transport company payload');
  }
  return normalized;
}
